var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Drawer as AntDrawer } from 'antd';
import { ConfigContext } from 'antd/es/config-provider/context';
import { getUiDirection } from 'library/utilities/Internationalization';
/**
 * Drawer that opens from the reading-direction end by default:
 * LTR → right, RTL (Arabic) → left.
 * Only remaps placement="right"; callers that already pass "left" for RTL are left alone.
 */
var Drawer = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'right' : _b, rest = __rest(_a, ["placement"]);
    var direction = useContext(ConfigContext).direction;
    var isRtl = direction === 'rtl' || getUiDirection(document.documentElement.getAttribute('lang')) === 'rtl';
    var resolved = isRtl && placement === 'right' ? 'left' : placement;
    return _jsx(AntDrawer, __assign({ placement: resolved }, rest));
};
export default Drawer;
